export enum PresenceAvailability {
	None = 0,
	Online = 3000,
	IdleOnline = 4500,
	Busy = 6000,
	IdleBusy = 7500,
	DoNotDisturb = 9000,
	BeRightBack = 12000,
	Away = 15000,
	Offline = 18000,
}

export interface PresenceDto {
	id?: string;
	availability: string;
	activity: string;
	presenceType?: PresenceAvailability;
	updatedAt?: string | null;
}

export interface PresenceListItemDto {
	id: string;
	availability: string;
	activity: string;
	reasons: ReasonListItemDto[];
}

export interface ReasonListItemDto {
	id: string;
	name: string;
	presence: number;
	isDeleted: boolean;
	queueRef: string;
}

export interface PresenceChangeModel {
	sip?: string;
	presence?: string;
	note?: string;
	id?: string;
	changedBy?: string;
	wrapUpCodeId?: string;
	wrapUpCodeName?: string;
}

export interface UserPresenceChanged {
	userId: string;
	availability: string;
	activity: string;
	upn: string;
	azureId: string;
	clearCallInfo: boolean;
	wrapupMediaId?: string;
}

export interface InternalPresenceDto {
	hasClient: boolean;
	reason?: string;
	presence: PresenceDto;
	lastHandledTime?: Date;
	isChangedByAgent: boolean;
	agentAlreadyInHandling: boolean;
}